(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-single-sample"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ua-single').forEach(root=>{
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  const products=JSON.parse(root.querySelector('[data-single-products]').textContent),text=JSON.parse(root.querySelector('[data-single-text]').textContent),dialog=root.querySelector('dialog'),options=root.querySelector('.ua-single-options'),search=root.querySelector('input[type="search"]'),picker=root.querySelector('.ua-single-picker');let chosen=products.find(p=>p.handle==='beacon')||products[0];
  const normalize=value=>value.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().trim();
  const config=JSON.parse(root.querySelector('[data-single-config]').textContent),buy=root.querySelector('.ua-single-buy');let busy=false;
  const describe=(target,p)=>{target.replaceChildren();const title=document.createElement('strong'),inspiration=document.createElement('small');title.textContent=p.title;inspiration.textContent=p.inspired;target.append(title,inspiration);};
  const render=()=>{const img=document.createElement('img');img.src=chosen.image+'&width=700';img.alt=chosen.title+' '+text.alt;img.width=700;img.height=700;img.fetchPriority='high';root.querySelector('[data-single-image]').replaceChildren(img);describe(root.querySelector('[data-single-name]'),chosen);describe(root.querySelector('[data-single-caption]'),chosen);options.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.handle===chosen.handle)));root.querySelector('.ua-single-summary').hidden=true;root.querySelector('.ua-single-status').textContent='';};
  products.forEach(p=>{const b=document.createElement('button'),img=document.createElement('img'),copy=document.createElement('span');b.type='button';b.className='ua-single-option';b.dataset.handle=p.handle;b.dataset.search=normalize(p.title+' '+p.inspired+' '+p.family);img.src=p.image+'&width=240';img.alt=p.title+' '+text.alt;img.loading='lazy';img.width=240;img.height=240;describe(copy,p);b.append(img,copy);b.addEventListener('click',()=>{chosen=p;render();dialog.close();picker.focus();});options.append(b);});
  picker.addEventListener('click',()=>{search.value='';options.querySelectorAll('button').forEach(b=>b.hidden=false);root.querySelector('.ua-single-empty').hidden=true;dialog.showModal();search.focus();});
  root.querySelector('.ua-single-close').addEventListener('click',()=>{dialog.close();picker.focus();});dialog.addEventListener('cancel',()=>picker.focus());
  search.addEventListener('input',()=>{const q=normalize(search.value);let count=0;options.querySelectorAll('button').forEach(b=>{b.hidden=!b.dataset.search.includes(q);if(!b.hidden)count++;});root.querySelector('.ua-single-empty').hidden=count>0;});
  buy.addEventListener('click',async()=>{
    const status=root.querySelector('.ua-single-status');
    if(config.preview!==false){const summary=root.querySelector('.ua-single-summary');root.querySelector('[data-single-summary]').textContent=chosen.title+' · 5ml — '+chosen.inspired;summary.hidden=false;status.textContent=text.preview;summary.focus({preventScroll:false});return;}
    if(busy)return;busy=true;buy.disabled=true;buy.setAttribute('aria-busy','true');status.textContent=text.pending;
    try{
      const cartResponse=await fetch(config.cart+'.js',{credentials:'same-origin',cache:'no-store'});if(!cartResponse.ok)throw new Error();const cart=await cartResponse.json(),introIds=new Set(products.map(p=>String(p.intro_variant)));
      if(cart.items.some(item=>introIds.has(String(item.variant_id)))){status.textContent=text.exists+' ';const link=document.createElement('a');link.href=config.cart;link.textContent=text.cart;status.append(link);return;}
      const response=await fetch(config.add,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(chosen.intro_variant),quantity:1}]})});if(!response.ok)throw new Error();const added=await response.json();if(!added.items?.some(item=>String(item.variant_id||item.id)===String(chosen.intro_variant)))throw new Error();window.location.assign(config.root+'checkout');
    }catch{status.textContent=text.error;}finally{busy=false;buy.disabled=false;buy.removeAttribute('aria-busy');}
  });
  render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua-trial-duo"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ua-duo').forEach(root=>{
  if(root.dataset.initialized)return;root.dataset.initialized='true';
  const products=JSON.parse(root.querySelector('[data-duo-products]').textContent),text=JSON.parse(root.querySelector('[data-duo-text]').textContent),chosen=[products.find(p=>p.handle==='beacon'),products.find(p=>p.handle==='flint')],dialog=root.querySelector('dialog'),options=root.querySelector('.ua-duo-options'),search=root.querySelector('input[type="search"]');let slot=0,opener;
  const render=()=>chosen.forEach((p,i)=>{const image=root.querySelector(`[data-duo-image="${i}"]`),name=root.querySelector(`[data-duo-name="${i}"]`);image.replaceChildren();const img=document.createElement('img');img.src=p.image+'&width=700';img.alt=p.title+' 5ml Eau de Parfum vial';img.width=700;img.height=700;image.append(img);name.replaceChildren();const strong=document.createElement('strong'),small=document.createElement('small');strong.textContent=p.title;small.textContent=p.inspired;name.append(strong,small);});
  products.forEach(p=>{const b=document.createElement('button'),img=document.createElement('img'),strong=document.createElement('strong'),small=document.createElement('small');b.type='button';b.className='ua-duo-option';b.dataset.search=(p.title+' '+p.inspired+' '+p.family).toLowerCase();img.src=p.image+'&width=240';img.loading='lazy';img.width=240;img.height=240;img.alt=p.title+' 5ml vial';strong.textContent=p.title;small.textContent=p.inspired;b.append(img,strong,small);b.addEventListener('click',()=>{chosen[slot]=p;render();dialog.close();opener?.focus();});options.append(b);});
  root.querySelectorAll('[data-duo-slot]').forEach(b=>b.addEventListener('click',()=>{slot=Number(b.dataset.duoSlot);opener=b;search.value='';options.querySelectorAll('button').forEach(o=>o.hidden=false);root.querySelector('.ua-duo-empty').hidden=true;dialog.showModal();search.focus();}));
  root.querySelector('.ua-duo-close').addEventListener('click',()=>{dialog.close();opener?.focus();});
  search.addEventListener('input',()=>{const q=search.value.toLowerCase().trim();let count=0;options.querySelectorAll('button').forEach(o=>{o.hidden=!o.dataset.search.includes(q);if(!o.hidden)count++;});root.querySelector('.ua-duo-empty').hidden=count>0;});
  root.querySelector('.ua-duo-buy').addEventListener('click',async()=>{const status=root.querySelector('.ua-duo-status');if(root.dataset.preview==='true'){status.textContent=text.preview;return;}status.textContent='';const b=root.querySelector('.ua-duo-buy');b.disabled=true;try{const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(root.dataset.bundleId),quantity:1,properties:{'Fragrance 1':chosen[0].title+' — '+chosen[0].inspired,'Fragrance 2':chosen[1].title+' — '+chosen[1].inspired,'_sample_variant_1':chosen[0].variant,'_sample_variant_2':chosen[1].variant,'_ua_offer':'trial-duo'}}]})});if(!res.ok){const error=await res.json();throw new Error(error.description||error.message);}location.assign('/cart');}catch(e){status.textContent=e.message;}finally{b.disabled=false;}});render();
});

  } catch(e) { console.error(e); }
})();
})();
